// @ts-expect-error
import { jitsiLocalStorage } from '@jitsi/js-utils';
import { Box, Slider, styled, Typography } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Icon from "../../../../base/icons/components/Icon";
import { IconLayoutTile, IconLayoutTile2 } from "../../../../base/icons/svg";
import Switch from "../../../../base/ui/components/web/Switch";
import { toString } from '../../../../base/util/functions';
import { setIsPaging } from '../../../../filmstrip/actions.web';
import { setTileViewMode } from "../../../../video-layout/actions.any";
const TileSlider = styled(Slider)({
    color: '#fff',
    width: '64%',
    margin: '18px 0',
    height: 1,
    '& .MuiSlider-track': {
        border: 'none',
    },
    '& .MuiSlider-thumb': {
        height: 12,
        width: 12,
        border: '2px solid currentColor',
        '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
            boxShadow: 'inherit',
        },
        '&:before': {
            display: 'none',
        },
    },
    '& .MuiSlider-valueLabel': {
        lineHeight: 1.2,
        fontSize: 12,
        background: 'unset',
        padding: 0,
        width: 32,
        height: 32,
        color: '#000',
        borderRadius: '50% 50% 50% 0',
        backgroundColor: '#fff',
        transformOrigin: 'bottom left',
        transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
        '&:before': { display: 'none' },
        '&.MuiSlider-valueLabelOpen': {
            transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
        },
        '& > *': {
            transform: 'rotate(45deg)',
        },
    },
    '& .MuiSlider-rail': {
        backgroundColor: "#8F9294",
        opacity: '1'
    },
    '& .MuiSlider-markLabel': {
        color: '#fff'
    }
});
const marks = [
    {
        value: 3,
        label: '2x2',
    },
    {
        value: 8,
        label: '3x3',
    },
    {
        value: 15,
        label: '4x4',
    },
    {
        value: 24,
        label: '5x5',
    },
];
function valuetext(value) {
    return `${value}`;
}
function valueLabelFormat(value) {
    return value + 1;
}
const TileViewDetail = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { tileViewMode, isPaging } = useSelector((state) => state['features/filmstrip']);
    const [valueTile, setValueTile] = useState(tileViewMode - 1);
    const handleChangeTileViewValue = (value) => {
        setValueTile(value);
        dispatch(setTileViewMode(value + 1));
    };
    return (React.createElement(Box, { sx: { width: '320px', height: '247px', backgroundColor: '#242528' } },
        React.createElement(Box, { sx: { height: '40px', backgroundColor: '#333333', display: 'flex', alignItems: 'center', padding: '0 24px' } },
            React.createElement(Typography, { sx: { color: '#fff', fontSize: '14px', fontFamily: 'Sarabun' } }, t('dialog.layout.number'))),
        React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', padding: '8px' } },
            React.createElement(Typography, { sx: { color: '#fff', padding: '8px 16px', fontSize: '14px', fontFamily: 'Sarabun' } }, t('dialog.layout.descNumber')),
            React.createElement(Box, { sx: { display: 'flex', justifyContent: "space-between", alignItems: 'center', padding: '0px 20px 12px 20px' } },
                React.createElement(Box, { sx: {
                        '& path': {
                            fill: '#fff'
                        }
                    } },
                    React.createElement(Icon, { src: IconLayoutTile, size: 24 })),
                React.createElement(TileSlider, { "aria-label": "Restricted values", defaultValue: valueTile, min: 3, max: 24, valueLabelFormat: valueLabelFormat, getAriaValueText: valuetext, step: null, valueLabelDisplay: "auto", marks: marks, disabled: false, onChange: (e, newValue) => { handleChangeTileViewValue(newValue); } }),
                React.createElement(Box, { sx: {
                        '& path': {
                            fill: '#fff'
                        }
                    } },
                    React.createElement(Icon, { src: IconLayoutTile2, size: 24 })))),
        React.createElement(Box, { sx: { display: 'flex', padding: '17px 24px', justifyContent: 'space-between', borderTop: '1px solid #44494D' } },
            React.createElement(Typography, { sx: { color: '#fff', fontSize: '14px', fontFamily: 'Sarabun' } }, t('dialog.layout.isPaging')),
            React.createElement(Switch, { checked: Boolean(isPaging), onChange: (val) => {
                    dispatch(setIsPaging(Boolean(val)));
                    jitsiLocalStorage.setItem("isPaging", toString(val));
                }, disabled: false }))));
};
export default TileViewDetail;
